import { defineComponent, onBeforeUpdate, useCssModule, useRoute, useRouter } from '@nuxtjs/composition-api';
import { reactive } from '@vue/composition-api';
import { createHead } from '~/utils';
const TABS = [
    {
        title: 'Статьи',
        value: '/club',
    },
    {
        title: 'О клубе',
        value: '/club/about',
    },
    {
        title: 'Лица',
        value: '/club/faces',
    },
    {
        title: 'Мероприятия',
        value: '/club/events',
    },
    {
        title: 'Партнерские проекты',
        value: `/club/partners`,
    },
];
export default defineComponent({
    name: 'PageClub',
    scrollToTop: true,
    setup() {
        /**
         * CSS Composables.
         */
        const css = useCssModule();
        const route = useRoute();
        const router = useRouter();
        const tabs = reactive({
            change(tab) {
                tabs.currentTab = tab;
                router.push(`${tab.value}`);
            },
            currentTab: {
                title: '',
                value: '',
            },
            tabs: [...TABS],
        });
        setCurrentTab();
        onBeforeUpdate(() => {
            setCurrentTab();
        });
        function setCurrentTab() {
            tabs.currentTab =
                TABS.find(({ value, isDynamic }) => {
                    if (isDynamic) {
                        return route.value.path.replace(/\/$/g, '').includes(value);
                    }
                    return value === route.value.path.replace(/\/$/g, '');
                }) || TABS[0];
        }
        return {
            css,
            tabs,
        };
    },
    async asyncData(context) {
        const { app, env, error, route } = context;
        try {
            const title = 'Forbes Club';
            const head = {
                canonical: env.HOST + route.path,
                title,
                image: '/share-club.png',
                url: env.HOST + route.path,
            };
            context.$page = app.$page = {
                title,
            };
            return {
                $page: context.$page,
                head,
            };
        }
        catch (e) {
            console.error(e);
            error({ statusCode: 404 });
        }
    },
    head() {
        return createHead(this.head);
    },
});
